import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CacheProvider } from '@emotion/react';
import { ApiProvider } from '@lib/react/api';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { GlobalStateProvider } from '@shared/components/common/GlobalStateContext';
import { CustomThemeProvider } from '@shared/theme/theme';
import createEmotionCache from '@shared/components/common/createEmotionCache';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from '@shared/i18n';
import { initializeClientConfig } from '@shared/utils/client-config';

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // networkMode: process.env.NODE_ENV === 'development' ? 'always' : undefined,
    },
    mutations: {
      // networkMode: process.env.NODE_ENV === 'development' ? 'always' : undefined,
    },
  },
});

// Initialize client config (including MUI license) before rendering
initializeClientConfig().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <I18nextProvider i18n={i18n}>
            <CacheProvider value={clientSideEmotionCache}>
              <ApiProvider baseUrl="/api/v2">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <GlobalStateProvider>
                    <CustomThemeProvider>
                      <CssBaseline />
                      <App />
                    </CustomThemeProvider>
                  </GlobalStateProvider>
                </LocalizationProvider>
              </ApiProvider>
            </CacheProvider>
          </I18nextProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
});
